// extracted by mini-css-extract-plugin
export default {"tab":"style_tab__UXZ7m","text":"style_text__ej7hg","activeText":"style_activeText__3XBJu"};